<template>
	<section class="py-400 py-500-md position-relative bg-color-greige">
		<div class="container">
			<h2 class="heading-2 font-weight-lighter line-height-125 text-align-center mb-100 mb-200-md"
				>Important details</h2
			>
			<div class="faq-section col-10-md col-6-lg ml-auto mr-auto">
				<QuestionList :question-items="questionList" />
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
import { QuestionItem } from 'types/layout';
import QuestionList from '@components/layout/question-list.vue';

const questionList: Array<QuestionItem> = [
	{
		question: 'What is Fundrise Pro?',
		answer: `
				<p>Fundrise Pro is a membership that allows investors to take total control of their investment portfolio. For $10/month, Pro members can create custom investment plans and make direct investments into all available funds on Fundrise, including strategy-specific funds with limited access.</p>
			`
	},
	{
		question: 'What features can I access with Fundrise Pro?',
		answer: `
				<p>Fundrise Pro members will have access to the following features:</p>
				<ul class="ul ml-100">
					<li>
						<span><strong>Direct investment:</strong>&nbsp;Make one-off investments into specific funds.</span>
					</li>
					<li>
						<span><strong>Custom plans:</strong>&nbsp;Build your own portfolio with full allocation control.</span>
					</li>
				</ul>
				<p>Fundrise Pro members will have access to all standard Fundrise account features in addition to the features above.</p>
			`
	},
	{
		question: 'Can I cancel my membership at any time?',
		answer: `
				<p>The Fundrise Pro membership can be cancelled at any time.</p>
				<p>That said, the membership will automatically renew unless cancelled by the user.</p>
				<p>To cancel your membership please navigate to your <a class="text-decoration-underline text-color-current-color" href="/account/profile/contact-information">Profile & Preferences</a> under the <a class="text-decoration-underline text-color-current-color" href="/account/profile/fundrise-pro/">Fundrise Pro</a> settings page.</p>
			`
	}
];
</script>
